import React from 'react';
import "./menu.less";
import { Popover } from '../Popover/Popover';

export interface ItemProps {
  itemKey: string | number;
  title?: string;
  url?: any;
  onClick?: (key: string | number) => void;
  className?: string;
  children?: React.ReactNode;
  mode?: 'vertical' | 'horizontal' | 'inline';
  selected: string | number | null;
  setSelected: (key: string | number | null) => void; 
}

export const Item: React.FC<ItemProps> = ({ 
  itemKey, 
  title, 
  onClick, 
  className, 
  children, 
  mode = "inline",
  selected,
  url,
  setSelected,
}) => {

  const handleClick = () => {
    if (onClick) {
      onClick(itemKey);
      setSelected(itemKey);
    }
  };

  switch (mode) {
    case 'inline':
      return (
        <li 
          key={itemKey} 
          onClick={handleClick} 
          className={"bp2-menu-item " + (className ? className : '') + (selected === itemKey || window.location.pathname === url ? ' selected' : '')} 
          title={title}
        >
          {children}
        </li>
      );
    case 'vertical':
      return (
        <li 
          key={itemKey} 
          className={"bp2-menu-item " + (className ? className : '') + (selected === itemKey || window.location.pathname === url ? ' selected' : '')} 
          onClick={handleClick} 
        >
          <Popover 
            trigger="hover" 
            placement="right"
            overlayClassName={`bp2-menu-list vertical`}
            content={title}
          >
            {children}
          </Popover>
        </li>
      );
    case 'horizontal':
      return (
        <li 
          key={itemKey} 
          className={"bp2-menu-item " + (className ? className : '') + (selected === itemKey || window.location.pathname === url ? ' selected' : '')} 
          onClick={handleClick} 
        >
          <Popover 
            trigger="hover" 
            placement="bottom"
            overlayClassName={`bp2-menu-list vertical`}
            content={title}
          >
            {children}
          </Popover>
        </li>
      );
    default:
      return null;
  }
};